import { ReactNode } from "react";
import styled, { css } from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

import { StatusTone, toneForStatus } from "./statusTone";

const { color, radius, statusTone } = adminTokens;

// The design's Status badges rule: a 22px pill, Medium 12, 10px each side.
const pillHeight = 22;
const pillPadding = 10;

const pillStyle = css`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: ${pillHeight}px;
  padding: 0 ${pillPadding}px;
  border: 1px solid transparent;
  border-radius: ${radius.pill}px;
  font-family: ${adminTokens.typeScale.labelValue.fontFamily};
  font-size: 12px;
  white-space: nowrap;
`;

const Badge = styled.span<{ $tone: StatusTone }>`
  ${pillStyle}
  background-color: ${({ $tone }) => statusTone[$tone].background};
  border-color: ${({ $tone }) => statusTone[$tone].border};
  color: ${({ $tone }) => statusTone[$tone].text};
`;

const TagPill = styled.span`
  ${pillStyle}
  background-color: ${color.sage};
  color: ${color.navy};
`;

interface StatusBadgeProps {
  status: string;
  label?: string;
}

// Shows a backend status value as received; its look follows from the value
// (BADGE-R1…R9). Given a plain-language label, it reads the label and keeps the value as its
// hover text (BADGE-R12).
export const StatusBadge = ({ status, label }: StatusBadgeProps) => (
  <Badge $tone={toneForStatus(status)} title={label === undefined ? undefined : status}>
    {label ?? status}
  </Badge>
);

// A label that is not a status, such as "Current", "Reship" or "ADMIN"
// (BADGE-R10).
export const Tag = ({ children }: { children: ReactNode }) => <TagPill>{children}</TagPill>;
